 


 // StripeDonationForm.jsx
import React, { useState } from 'react'
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-hot-toast'
import axios from 'axios'
import { BASE_URL } from '../BaseURL'
import '../Assets/Css/stripepayform.css'
import { BiArrowBack } from 'react-icons/bi';
import { Container } from 'react-bootstrap'

const StripeDonationForm = ({ formData }) => {
  const stripe = useStripe()
  const elements = useElements()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const handleBack = () => {
    navigate(-1); // 👈 Go back one step
  };


// const handlePayment = async (e) => {
//   e.preventDefault();
//   setLoading(true);

//   try {
//     const { data } = await axios.post(`${BASE_URL}/donation/stripePayment`, {
//       amount: formData.amount,
//       name: formData.fullName,
//     });

//     if (!data.success) {
//       toast.error(data.message || 'Payment failed');
//       return;
//     }

//     const result = await stripe.confirmCardPayment(data.clientSecret, {
//       payment_method: {
//         card: elements.getElement(CardElement),
//         billing_details: {
//           name: formData.fullName,
//           email: formData.email,
//           address: {
//             line1: formData.address,
//             postal_code: formData.pinCode,
//           },
//         },
//       },
//     });

//     if (result.error) {
//       toast.error(result.error.message);
//     } else if (result.paymentIntent.status === 'succeeded') {
//       navigate('/confirmation'); // ✅ Redirect on success
//     }
//   } catch (err) {
//     console.error(err);
//     toast.error('Something went wrong.');
//   } finally {
//     setLoading(false);
//   }
// };

const handlePayment = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    // ✅ Step 1: Send full form data to backend to create PaymentIntent
    const { data } = await axios.post(`${BASE_URL}/donation/stripePayment`, {
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      address: formData.address,
      pinCode: formData.pinCode,
      amount: formData.amount,
    });

    if (!data.success || !data.clientSecret) {
      toast.error(data.message || 'Payment initiation failed.');
      return;
    }

    // ✅ Step 2: Confirm the payment using Stripe Elements
    const result = await stripe.confirmCardPayment(data.clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name: formData.fullName,
          email: formData.email,
          address: {
            line1: formData.address,
            postal_code: formData.pinCode,
          },
        },
      },
    });

    // ✅ Step 3: Handle result
    if (result.error) {
      toast.error(result.error.message || 'Payment confirmation failed.');
    } else if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
      toast.success('🎉 Donation successful!');
      navigate('/confirmation');
    } else {
      toast.error('Payment was not successful. Please try again.');
    }

  } catch (err) {
    console.error('Payment Error:', err);
    toast.error('Something went wrong while processing your payment.');
  } finally {
    setLoading(false);
  }
};




  return (
    <>

<div  className='stripe-container'>
   <Container>
     <button onClick={handleBack} className="btn btn-link">
      <BiArrowBack size={20} /> Back
    </button>
      <div className="payment-wrapper">
        <div className="payment-card">
          <div className="virtual-card">
            <div className="chip" />
            <div className="card-details">
              <div className="name">XtraGrow</div>
              <div className="expiry">09/50</div>
              <div className="number">0000 0000 0000 1600</div>
              <div className="visa">XtraGrow Foundation</div>
            </div>
          </div>

          <div className="form-area">
            <div className="input-group">
              <label>Amount (USD)</label>
              <input type="number" value={formData.amount} readOnly className="readonly" />
            </div>

            <div className="input-group">
              <label>Card Details</label>
              <div id="card-container" className="card-input">
                <CardElement
                  options={{
                    style: {
                      base: {
                        fontSize: '16px',
                        color: '#333',
                        '::placeholder': { color: '#ccc' },
                      },
                      invalid: { color: '#e5424d' },
                    },
                  }}
                />
              </div>
            </div>

            <div className="button-row">
              <button className="cancel-btn" onClick={() => navigate('/')}>
                Cancel
              </button>
              <button
                className="submit-btn"
                onClick={handlePayment}
                disabled={!stripe || loading}
              >
                {loading ? 'Processing...' : 'Submit'}
              </button>
            </div>
          </div>
        </div>
      </div>
      </Container>
</div>

   
    </>
  )
}

export default StripeDonationForm
